<template>
  <div class="main-body">
    <div class="header">
      护理级别
    </div>
    <div class="out">

      <div class="search2">


          <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <el-button size="mini" type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>

        <div style="float:right">
          <el-input  placeholder="请输入等级名称" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
          <el-select v-model="status" placeholder="选择房间等级状态" style="margin:0 10px;">
            <el-option
                v-for="item in statusValue"
                :key="item[0]"
                :label="item[1]"
                :value="item[0]">
            </el-option>
          </el-select>
          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="price" label="价格(元/天)" v-if="dayShow"></el-table-column>
        <el-table-column prop="priceMonth" label="价格(元/月)" v-if="monthShow"></el-table-column>

        <el-table-column prop="sort" label="排序"></el-table-column>

        <el-table-column prop="sort" label="护理项目">
          <template slot-scope="scope">
            <el-tag v-for="item in scope.row.nursingItemList" :key="item.institutionCode" style="margin:5px">{{item.name}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
            prop="Status"
            :formatter="statusTitle"
            label="状态">
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:ItemList="ItemList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:ItemList="ItemList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode,getChargeTime} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      loading:false,
      dayShow:false,
      monthShow:false,
      menuButtonList:null,
      disabledAdd:false,
      disabledEdit:true,
      row:null,
      showModalAdd:false,
      showModalEdit:false,
      tableData:null,
      totalItems: 0,
      status:-1,
      name:'',
      pageSize:20,
      currentPage:1,
      th:0,
      ItemList:[],
      statusValue:[[-1,'全部状态'],[0,'正常'],[1,'禁用']]
    }
  },
  components:{
    Add,Edit
  },
  created(){
    if(getChargeTime()=="天"){
      this.dayShow=true;
    }else{
      this.monthShow = true;
    }
    this.init();
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    rowClick(row){
      this.row=row;
      //if(this.menuButtonList.indexOf("编辑")!=-1){
        this.disabledEdit =false;
      //}

    },
    init(){
      this.getItemList()
    },
    getItemList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingItem/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.ItemList = response.data.data;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleEdit() {
      this.$refs.myEdit.init(this.row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingLevel/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          status:this.status,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        this.disabledEdit = true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },



  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
</style>
